"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertMatchRules = void 0;
/**
 * @internal
 * Validates the match rules
 */
function assertMatchRules(rules) {
    if (rules.victoryPoints <= rules.defeatPoints)
        throw new Error("The victoryPoints should be higher than the defeatPoints");
    if (rules.defeatPoints < 0)
        throw new Error("The defeatPoints must be zero or positive");
}
exports.assertMatchRules = assertMatchRules;
